import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';
import { JobPosting } from '@/data/jobOptions';

export function useJobDetail(slug: string | undefined) {
  return useQuery({
    queryKey: ['job', slug],
    queryFn: async () => {
      if (!slug) throw new Error('Slug is required');

      const { data, error } = await supabase
        .from('job_postings')
        .select(`
          *,
          companies:company_id (
            id,
            name,
            slug,
            logo_url,
            is_verified,
            address_city
          )
        `)
        .eq('slug', slug)
        .eq('status', 'active')
        .gt('expires_at', new Date().toISOString())
        .single();

      if (error) throw error;

      return data as JobPosting;
    },
    enabled: !!slug,
    staleTime: 1000 * 60, // 1 minute
  });
}
